import logoUrl from "@/assets/logo-aknaucer.webp";

/** URL бренда: dev → https://dev.aknaucer.ru/, prod → https://aknaucer.ru/.
 *  Подставляется на сборке через VITE_BRAND_URL (web.env.j2). Дефолт — prod. */
const BRAND_URL = import.meta.env.VITE_BRAND_URL ?? "https://aknaucer.ru/";

/** Логотип «Акнауцер» в шапке. Ведёт на сайт компании. */
export default function BrandLogo() {
  return (
    <a className="cl-min__brand" href={BRAND_URL} aria-label="Акнауцер">
      <img className="cl-min__logo" src={logoUrl} alt="Акнауцер" height={28} />
    </a>
  );
}
